import React, { useEffect } from "react";
import "@ant-design/compatible/assets/index.css";
import { Button, Form } from "antd";

const CreateSelectForm = ({
  onSubmit,
  createStatus,
  formData,
  onFinishFailed,
  onFinish,
  isUserPermission = false,
  children,
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    formData(form);
  }, []);
  return (
    <Form
      form={form}
      onFinish={onFinish}
      onSubmit={onSubmit}
      onFinishFailed={onFinishFailed}
      labelCol={{
        xs: { span: 24 },
        sm: { span: 6 },
        md: { span: 6 },
        lg: { span: 6 },
        xl: { span: 6 },
        xxl: { span: 6 },
      }}
      wrapperCol={{
        xs: { span: 24 },
        sm: { span: 18 },
        md: { span: 18 },
        lg: { span: 15 },
        xl: { span: 15 },
        xxl: { span: 15 },
      }}
    >
      {children}

      <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
        {
          !isUserPermission && createStatus &&
          <Button type="primary" htmlType="submit">
            {createStatus && "Create"}
          </Button>
        }

      </Form.Item>
    </Form>
  );
};

export default CreateSelectForm;
